
<div class="row mx-0 align-items-center">
  <button class="q-btn q-main" (click)="GenerateDocs()"><i [ngClass]="[isGenerating ? 'fa-pulse fa-spin fa-spinner' : 'fa-save']" class="fas mr-2"></i>Générer</button>
  <!--#region bouton-->
  <div class="col-auto rounded-button ml-1 q-pointer"
       [ngClass]="[emptyModel ? 'q-danger' : 'q-dark-secondary']"
       placement="bottom"
       [autoClose]="'outside'"
       [ngbPopover]="f4"
       popoverClass="q-popover"
       #p4="ngbPopover"
       [title]="selectedModel.value">
    <span>
      <span class="q-bold">Modèle : </span>
      <span>{{selectedModel.value}}</span>
    </span>
  </div>
  <!--#endregion-->
  <!--#region popovers spécifiques à chaque format de valeur-->
  <ng-template #f4>
    <!--#region popover générique pour les combos-->
    <ng-container *ngIf="ModelsList && ModelsList.length > 0">
      <div class="q-hover q-pointer px-2" (click)="selectedModel$.next({id:'',value:'- - - - - -'}); p4.close()">- - - - - -</div>
      <ng-container *ngFor="let combo of ModelsList; let i = index">
        <div class="q-hover q-pointer px-2" (click)="emptyModel = false;selectedModel$.next({id: combo.id,value:combo.value}); p4.close()">{{combo.value}}</div>
      </ng-container>
    </ng-container>
    <!--#endregion-->
  </ng-template>
  <!--#endregion-->
  <q-dynamictags-inline #dynamictagsInline
                        class="col pl-0"
                        idDonnee="0" codeOrIdBo="BO_COURRIER"
                        [exceptColumnNames]="['Type_DOC', 'Path_DOC', 'DtcreDOC']"></q-dynamictags-inline>

  <!--<ng-container *ngTemplateOutlet="buttonRounded;context:{options: docService.nivseDOCOptions , selected: selectedNiveauDocExtranet, label: 'Niveau extranet'}"></ng-container>-->
</div>

<div *ngIf="selectedModel.id !== ''" class="row my-2">
  <div class="col-12 justify-content-center">Génération unitaire d'un document par:</div>
  <span (click)="ModeGeneration = 1" [ngClass]="[ModeGeneration == 1 ? 'bold col-auto q-pointer' : 'col-auto q-pointer']" >Apprenants</span>
  <input  class="col-auto p-0 m-0 switch" [ngClass]="[ModeGeneration == 3? 'rigth' :  ModeGeneration == 1? 'left' : 'middle']"
         type="range" name="switch" min="1" max="3"
         [(ngModel)]="ModeGeneration">
  <span (click)="ModeGeneration = 3" [ngClass]="[ModeGeneration == 3 ? 'bold col-auto q-pointer' : 'col-auto q-pointer']" >Clients</span>
</div>

<div *ngIf="selectedModel.id !== ''"  class="row my-2">

  <div class="effectif-container col-12 col-lg-6 col-xl-3 my-2">
    <q-effectifs  [Option]="OptionClient" (EffectifToEmit)="UpdateListEffectif($event, 'CLIENT')"  [docxpreselect$]="docxpreselect$" ></q-effectifs>
  </div>

  <div class="effectif-container col-12 col-lg-6 col-xl-3 my-2">
    <q-effectifs  [Option]="OptionStagiaire" (EffectifToEmit)="UpdateListEffectif($event, 'CONTACT')" [docxpreselect$]="docxpreselect$" [ListEffectifChecked]="getListSelected()"></q-effectifs>
  </div>

  <div class="h-100 col-12 col-lg-6 col-xl-4 my-2" *ngIf="docService.tabs[1].Active">
    <queoval-stage-list-reservation (LstIdReservation)="GetReservations($event)" [docxpreselect$]="docxpreselect$">></queoval-stage-list-reservation>
  </div>

  <div class="h-100 col-12 col-lg-6 col-xl-2 my-2">
    <fieldset class="q-fieldset h-100">
      <legend><i class="fas fa-chart-bar mr-2"></i>Rapport</legend>
      <div class="row report-body">
        <ng-container *ngFor="let report of docService.reportsList">
          <div [ngClass]="[model.IdReport == report.value ? 'bold col-12 q-check radio px-1 q-pointer' : 'col-12 q-check radio px-1 q-pointer']" >
            <input type="radio" name="reports" id="report-{{report.value}}" [value]="report.value" [(ngModel)]="model.IdReport" />
            <label for="report-{{report.value}}" class="q-pointer">
              <span></span>{{report.id}}
            </label>
          </div>
        </ng-container>
      </div>
    </fieldset>
  </div>

</div>

  <button class="btn q-btn q-danger m-1" type="button" (click)="open(ModalDeleteValidation, false)"
          title="Supprimer les documents sélectionnés" [disabled]="!selectedNodes || !selectedNodes?.length || selectedNodes.length < 1">
    <i class="fas fa-trash-alt"></i>
  </button>

  <!--<button title="Regénérer le document" class="btn q-btn m-1" (click)="open(ModalGenerateValidation, false)" [disabled]="!selectedNodes || !selectedNodes?.length || selectedNodes.length < 1">
    <i class="fas fa-print"></i> Regénérer doc
  </button>-->

  <q-customgrid customgridName="ListeCourriersStages"
                [idDonnee]="service.Stage.Ident"
                [(refreshData)]="refreshData"
                (selectChanged)="selectLine($event)">
  </q-customgrid>

  <!--  MODAL de validation de la suppression des documents -->
  <ng-template #ModalDeleteValidation let-modal class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement ces documents ?</h5>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="text-center">
        <button class="btn q-btn q-danger m-2" type="button" (click)="DeleteSelection();modal.dismiss()"
                title="Supprimer les documents" [disabled]="!selectedNodes?.length">
          Supprimer
        </button>
      </div>
    </div>
  </ng-template>

  <!--  MODAL de validation de regénération des documents -->
  <ng-template #ModalGenerateValidation let-modal class="modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="q-c-main text-center">Attention ! Vous allez remplacer les documents sélectionnés existants.</h5>
        <button type="button" class="close" (click)="modal.dismiss()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="text-center">
        <button class="btn q-btn m-2" type="button" (click)="RegenereDoc();modal.dismiss()"
                title="Générer les documents" [disabled]="!selectedNodes?.length">
          OK
        </button>
      </div>
    </div>
  </ng-template>
